import { ContentPage } from '../page-factory/content-page';
import { significanceOfMaghPage } from '../pages/page-kumbh-2025.gathering-of-magh';
import { getPageMeta } from '../pages/pages-types';

export const meta = () => getPageMeta(significanceOfMaghPage);

export default function SignificanceOfMaghPage() {
  return <ContentPage {...significanceOfMaghPage} />;
}
